/* ==========================================================================
   BOXX POP-UPS SECTION
   Collab With Us form — Klaviyo client-side submission
   ========================================================================== */

(function () {
  'use strict';

  var form = document.getElementById('boxx-collab-form');
  if (!form) return;

  form.addEventListener('submit', function (e) {
    e.preventDefault();

    var errorEl   = document.getElementById('collab-form-error');
    var successEl = document.getElementById('collab-form-success');
    errorEl.hidden   = true;
    successEl.hidden = true;

    var name    = form.querySelector('#collab-name').value.trim();
    var email   = form.querySelector('#collab-email').value.trim();
    var org     = form.querySelector('#collab-org').value.trim();
    var type    = form.querySelector('#collab-type').value;
    var message = form.querySelector('#collab-message').value.trim();

    if (!name || !email || !message) {
      errorEl.textContent = 'Name, email, and message are required.';
      errorEl.hidden = false;
      return;
    }

    var submitBtn = form.querySelector('[type="submit"]');
    var publicKey = (submitBtn.dataset.publicKey || '').trim() || 'UG6XDY';
    var listId    = (submitBtn.dataset.listId || '').trim();

    if (!listId) {
      errorEl.textContent = 'Something went wrong. Please try again.';
      errorEl.hidden = false;
      return;
    }

    submitBtn.textContent = 'Sending...';
    submitBtn.disabled = true;

    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + publicKey, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2024-02-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  first_name: name,
                  properties: {
                    organization: org,
                    collab_type:  type,
                    message:      message,
                    source:       'Collab Inquiry Form'
                  }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      })
    })
    .then(function (response) {
      if (response.ok || response.status === 202) {
        form.reset();
        submitBtn.textContent = 'Send Inquiry';
        submitBtn.disabled = false;
        successEl.hidden = false;
      } else {
        return response.text().then(function (text) {
          throw new Error('Status ' + response.status + ': ' + text);
        });
      }
    })
    .catch(function (err) {
      console.error('[boxx-collab] Klaviyo error:', err);
      submitBtn.textContent = 'Send Inquiry';
      submitBtn.disabled = false;
      errorEl.textContent = 'Something went wrong. Please try again.';
      errorEl.hidden = false;
    });
  });

})();